<template>
    <div class="applicationSection containerDiv mt-2 mb-2">
        <h5 class="application-label ContentSection line-hight0">
            Accessible Applications
            <span v-if="accessibleApplicationAccount.cadebillAccountNo != '' && isEditPermission"
                  class="margin-left-right-5px">|</span>
            <span v-if="accessibleApplicationAccount.cadebillAccountNo != '' && isEditPermission"
                  class="application-accountBu-text">{{accessibleApplicationAccount.cadebillAccountNo }} {{accessibleApplicationAccount.accountName}}</span>
            <!-- <font-awesome-icon :icon="applicationexpandStateIcon" class="float-right margin-point-4rem" /> -->
        </h5>
        <b-collapse id="application-list" visible>
            <b-card>
                <b-table :sticky-header="height"
                         striped
                         :busy.sync="isBusy"
                         :items="UserApplications"
                         :fields="columnsfield"
                         :show-empty="showempty"
                         no-border-collapse
                         head-variant="head-border">
                    <template v-slot:table-busy>
                        <div class="text-center">
                            <b-spinner class="align-middle gridSpinner"></b-spinner>
                            <strong>Loading...</strong>
                        </div>
                    </template>
                    <template v-slot:cell(isAccessible)="{ item }">
                        <!--<span class="float-left" v-if="item.isAccessible">
                            <font-awesome-icon icon="toggle-on"
                                               class="svg-green PointerCursor"
                                               v-on:click="ToggleApplicationAccess(item)" />Enabled

                        </span>
                        <span class="float-left" v-else>
                            <font-awesome-icon icon="toggle-off"
                                               class="svg-red PointerCursor"
                                               v-on:click="ToggleApplicationAccess(item)" />Disabled
                        </span>-->
                        <font-awesome-icon :icon="item.isAccessible == true? 'toggle-on':'toggle-off'" style="cursor:pointer;"
                                           :class="(item.isAccessible && (isUserEnable && !$store.getters.isImpersonation))? 'svg-green mr-1 ml-1' : (item.isAccessible && (!isUserEnable || $store.getters.isImpersonation))  ? 'svg-green mr-1 ml-1 disabledUserView' : (!item.isAccessible && (isUserEnable && !$store.getters.isImpersonation)) ? 'svg-red mr-1 ml-1' : 'svg-red mr-1 ml-1 disabledUserView' "
                                           :title="item.isAccessible == true? 'Enabled':'Disabled'"
                                           v-on:click="ToggleApplicationAccess(item)" />
                        <span v-if="item.isAccessible == true">Enabled</span>
                        <span v-else>Disabled</span>
                        <span v-if="isEditPermission == true && item.isAccessible && hasSupportSiteWebAccess && item.id!=4">
                            <span class="margin-left-5px">
                                |
                                <a class="link"
                                   @click="setApplicationPermmission(item.applicationName)">Edit Permission</a>
                            </span>
                        </span>
                        <div v-else></div>
                    </template>
                </b-table>
            </b-card>
        </b-collapse>
        <ErrorMessage :errorMessage="error" callbackOnClose></ErrorMessage>
    </div>
</template>

<script>
    import { eventbus } from "../../main";
    import service from "../../services/api.services";
    import appConstants from "../../constants/appConstants";
    import ErrorMessage from "./ErrorMessage";
    export default {
        name: "AccessibleApplications",
        components: {
            ErrorMessage
        },
        data() {
            return {
                applications: [],
                applicationexpandStateIcon: "plus-circle",
                isBusy: true,
                showempty: true,
                height: "",
                info: {
                    message: "",
                    title: ""
                },
                defaultapplication: "Customer Community",
                isEnabled: this.isUserEnable,
                changeStatusOfCommunity: false,
                UserApplications: [],
                error: "",
                hasSupportSiteWebAccess: false
            };
        },
        props: {
            username: String,
            sfContactID: String,
            adfsGuid: String,
            accessibleApplicationAccount: Object,
            isUserEnable: Boolean,
            isEditPermission: {
                type: Boolean,
                default: false
            },
            isConfirm: {
                type: Boolean,
                default: false
            },
            isCreate: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            columnsfield: function () {
                var fields = [
                    {
                        key: "applicationName",
                        tdClass: ["th-td-width", "cell-ellipsis", "application-tdClass"],
                        thClass: ["th-td-width", "application-thClass"]
                    },
                    {
                        key: "isAccessible",
                        label: "Access",
                        tdClass: ["th-td-min-width", "cell-ellipsis", "application-tdClass"],
                        thClass: ["th-td-min-width", "application-thClass"]
                    },
                    {
                        key: "sfAccountContactRelationId",
                        tdClass: "display-none",
                        thClass: "display-none"
                    }
                ];
                return fields;
            }
        },
        watch: {
            changeStatusOfCommunity: function (val) {
                this.UserApplications.forEach(function (app) {
                    if (app.id == appConstants.CustomerCommunityAppId) {
                        app.isAccessible = val;
                        app.applicationName = "Customer Community/Support Site";
                    }
                });
            },
            applications: function () {
                this.setCustomerCommunityData();
            }
        },
        mounted() {
            var that = this;
            that.applications = [];
            if (that.isConfirm == true || that.isCreate == true) {
                that.GetAccessiblePermission(
                    that.accessibleApplicationAccount.cadebillAccountNo
                );
            } else {
                that.applications = that.accessibleApplicationAccount.applicationDetails;
                that.isBusy = false;
            }
            that.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
                if (collapseId == "application-list") {
                    if (isJustShown) {
                        that.applicationexpandStateIcon = "minus-circle";
                    } else {
                        that.applicationexpandStateIcon = "plus-circle";
                    }
                }
            });
            that.setCustomerCommunityData();
        },
        methods: {
            setCustomerCommunityData: function () {
                var customerCommunityAppList = [];
                var AllApplist = [];
                var Communityname = "";
                var isAccessible = false;
                var isPartnerCommunityEnabled = false;
                var that = this;
                that.applications.forEach(function (application) {
                    if (application.id == appConstants.CustomerCommunityAppId) {
                        customerCommunityAppList.push(application);
                    }
                    else if (application.id == appConstants.PartnerCommunityAppId && application.isAccessible) {
                        AllApplist.push(application);
                        isPartnerCommunityEnabled = true;
                        //that.hasSupportSiteWebAccess = false;
                    }
                    else if (application.id == appConstants.SupportSiteAppId && application.isAccessible) {
                        application.applicationName = "Support Site";
                        AllApplist.push(application);
                        that.hasSupportSiteWebAccess = application.isAccessible;
                    }
                });
                //if (AllApplist.length > 0) {
                //    //Communityname = "Partner Community/Support Site";
                //    AllApplist.forEach(function (app) {
                //        if (app.id == appConstants.PartnerCommunityAppId) {
                //            app.applicationName = Communityname;
                //        }
                //    });
                //    //AllApplist.push({ id: appConstants.PartnerCommunityAppId, isAccessible: isAccessible, applicationName: Communityname });
                //}
                if (!isPartnerCommunityEnabled) {
                    AllApplist = [];
                    if (customerCommunityAppList != null || customerCommunityAppList != undefined) {
                        if (customerCommunityAppList.length > 0) {
                            Communityname = "Customer Community/Support Site";
                            customerCommunityAppList.forEach(function (app) {
                                if (app.id == appConstants.CustomerCommunityAppId) {
                                    isAccessible = app.isAccessible;
                                    that.hasSupportSiteWebAccess = true;
                                }
                            });
                            AllApplist.push({ id: appConstants.CustomerCommunityAppId, isAccessible: isAccessible, applicationName: Communityname });
                        }
                    }
                }
                that.UserApplications = AllApplist;              
            },

            async GetAccessiblePermission(accountNumber) {
                var that = this;
                var isPartnerUserAdd = (this.$store.getters.searchedUserDetail != null
                    && this.$store.getters.searchedUserDetail.userCommunityType == "Partner User"
                    && !this.$store.getters.searchedUserDetail.isCustomerCommunityUser);

                if (that.isCreate != true || isPartnerUserAdd) {
                    that.isBusy = true;
                    var userName;

                    if (isPartnerUserAdd) {
                        userName = this.$store.getters.searchedUserDetail.userName
                    } else {
                        userName = that.username;
                    }
                    await service
                        .GetAccessiblePermission(userName, accountNumber)
                        .then(result => {
                            that.applications = result.data;
                            if (!that.isEditPermission) {
                                that.applications.forEach(function (application) {
                                    if (application.applicationName == that.defaultapplication)
                                        application.isAccessible = true;
                                });
                            }
                            that.isBusy = false;
                        })
                        .catch(error => {
                            console.log(error);
                            that.applications = [];
                            that.isBusy = false;
                        });
                }
                else {
                    that.applications = []
                    that.applications.push({ applicationName: that.defaultapplication, isAccessible: true, id: appConstants.CustomerCommunityAppId });
                    that.isBusy = false;
                }
            },
            async EnableCustomerCommunity() {
                var that = this;
                that.isBusy = true;
                var userDetail = {
                    userName: that.username,
                    accountNumber: that.accessibleApplicationAccount.cadebillAccountNo,
                    sFContactId: that.sfContactID,
                    enabled: that.isUserEnable,
                    adfsGuid: that.adfsGuid
                };              
                await service
                    .EnableCustomerCommunity(userDetail)
                    .then(result => {
                        if (result.data.isEnabled) {
                            that.changeStatusOfCommunity = true;
                            that.isBusy = false;
                            that.onUserCommunityAccessChanged();
                        }
                        else
                            that.changeStatusOfCommunity = false;
                    })
                    .catch(error => {
                        that.error = "error occured while enabling customer community access."
                        that.$bvModal.show("errormessage");
                        console.log(error);
                        that.isBusy = false;
                    });
            },
            onUserCommunityAccessChanged() {
                this.$emit("UserCommunityAccessChanged", this.changeStatusOfCommunity)
            },
            ToggleApplicationAccess: function (row) {
                var that = this;
                if (!that.isUserEnable && row.id == appConstants.CustomerCommunityAppId && !row.isAccessible) {

                    that.error = "Enable the user to access customer community and edit permissions.";
                    that.$bvModal.show("errormessage");
                }
                else {
                    if (row.id == appConstants.CustomerCommunityAppId && !row.isAccessible) {
                        that.EnableCustomerCommunity();
                    }
                }
            },
            getvalue: function () {
                eventbus.$emit("setAccessibleApplications", this.applications);
            },
            getConfirmvalue: function () {
                eventbus.$emit("setConfirmAccessibleApplications", this.applications);
            },
            setApplicationPermmission: function (title) {
                if (this.isConfirm == true) {
                    eventbus.$emit("setConfirmApplicationSetting", title);
                } else {
                    var data = {
                        title: title,
                        account: this.accessibleApplicationAccount
                    };
                    eventbus.$emit("setApplicationSetting", data);
                }
            }
        }
    };
</script>